import { createFormContext } from '@mantine/form';

import { ActionSettingFormValue } from '#/components/ui/messages/model';

const [
  ActionEditorFormProvider,
  useActionEditorFormContext,
  useActionEditorForm,
] = createFormContext<ActionSettingFormValue>();

export {
  ActionEditorFormProvider,
  useActionEditorFormContext,
  useActionEditorForm,
};
